export enum C3OrderedProductStatus {
    Draft = 'Draft',
    Released = 'Released',
    Hold = 'Hold',
    Complete = 'Complete',
    Canceled = 'Canceled',
}
